export default __webpack_public_path__ + "static/media/download_googleplay.3815b154.svg";